import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
/* import { fetch } from '@ngrx/router-store/data-persistence'; */
import { fromAdUser } from '../reducers';
import { adUserActions } from '../actions';
import { GraphApi } from '../services';
import { catchError, map, switchMap } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../services";
import * as i2 from "@ngrx/effects";
export class AdUserEffects {
    constructor(api, actions$) {
        this.api = api;
        this.actions$ = actions$;
        this.loadUser$ = createEffect(() => this.actions$.pipe(ofType(adUserActions.LOAD_AD_USER), switchMap((action) => {
            const principalName = fromAdUser.parseUserEmail(action.payload);
            return this.api
                .getFullUserDetails(principalName)
                .pipe(map((user) => new adUserActions.LoadAdUserSuccess(user)), catchError(error => [
                new adUserActions.LoadAdUserFailed({
                    error: error,
                    message: `Unable to load Active Directory user profile for ${action.payload}`
                })
            ]));
        })));
    }
    static { this.ɵfac = function AdUserEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AdUserEffects)(i0.ɵɵinject(i1.GraphApi), i0.ɵɵinject(i2.Actions)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AdUserEffects, factory: AdUserEffects.ɵfac }); }
}
//# sourceMappingURL=ad-user.effects.js.map